import React, { useEffect, useState } from 'react';
import LoginCard from 'pages/auth/login/login-card';
import { ReactComponent as Logo } from 'assets/common/Logo-Red.svg';
import { ReactComponent as LiveTripsIcon } from 'assets/icons/live-trips.svg';
import { ReactComponent as SurgeIcon } from 'assets/icons/surge.svg';
import { ReactComponent as RidersIcon } from 'assets/icons/riders.svg';

const LeftLoginSection = () => {
  const [active, setActive] = useState(0);

  const increamentCounter = () => {
    setActive((active) => active + 1);
  };

  useEffect(() => {
    const interval = setInterval(increamentCounter, 3000);
    return () => clearInterval(interval);
  }, [active]);

  useEffect(() => {
    if (active === 3) {
      setActive(0);
    }
  }, [active]);

  return (
    <div className='w-full md:w-[40%] bg-white py-16 p-4 sm:p-8 md:p-16 space-y-10'>
      <Logo className='-ml-2' />
      <div>
        <h6 className='text-lg md:text-2xl lg:text-[32px] font-bold lg:leading-[36px]'>
          Hi, We’ve made your job easier
        </h6>
        <p className=' text-base text-gray-8 pt-2'>
          With easier flows, less cognitive load and minimal visuals, you can now monitor orders
          with ease
        </p>
      </div>

      <div className='space-y-4 transition-all duration-1000'>
        <LoginCard
          color='red'
          isActive={active === 0}
          details='Easily see how much your riders are earning  on each trips and watch your earnings rise. '
          title='Monitor Live Trips'
          icon={<LiveTripsIcon className='w-auto sm:w-[100px]' />}
        />
        <LoginCard
          color='blue'
          isActive={active === 1}
          details='Easily see how much your riders are earning  on each trips and watch your earnings rise.  '
          title='Manage Surge'
          icon={<SurgeIcon className='w-auto sm:w-[100px]' />}
        />
        <LoginCard
          color='yellow'
          isActive={active === 2}
          details='Easily see how much your riders are earning  on each trips and watch your earnings rise.  '
          title='Manage Riders'
          icon={<RidersIcon className='w-auto sm:w-[100px]' />}
        />
      </div>
    </div>
  );
};

export default LeftLoginSection;
